import { render } from "./ColorPickerButton.vue?vue&type=template&id=1bf0f908&scoped=true"
import script from "./ColorPickerButton.vue?vue&type=script&lang=js"
export * from "./ColorPickerButton.vue?vue&type=script&lang=js"

import "./ColorPickerButton.vue?vue&type=style&index=0&id=1bf0f908&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf0f908"]])

export default __exports__